import { NavigationItem } from '@app/components/navigation/NavigationItem';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Navigation } from '@typings';
import React from 'react';

interface Props {
  className?: string;
  items: Navigation.Item[];
  isNested?: boolean;
  onBlur?: (event: React.FocusEvent) => void;
  onLinkClick?: () => void;
}

export const NavigationMenuList = React.forwardRef<HTMLUListElement, Props>(
  ({ className, items, isNested = false, onBlur, onLinkClick }, ref) => {
    return (
      <ul ref={ref} className={cn('flex cursor-default flex-col gap-1 text-start', className)} onBlur={onBlur}>
        {items.map((item, index) => (
          <li key={index}>
            <NavigationItem
              item={item}
              className={cn('block px-2 py-1.5 text-neutral-20 body-1 focus-visible:rounded-large focus-visible:focus-outline', {
                'body-2': isNested,
                'hover:text-neutral-40': item.type !== 'folder',
              })}
              activeClassName="underline underline-offset-4"
              onClick={onLinkClick}
            />
            {item.type !== 'link' && isDefined(item.children) && !isEmpty(item.children) && (
              <NavigationMenuList items={item.children} isNested className="mt-1 pl-4" onLinkClick={onLinkClick} />
            )}
          </li>
        ))}
      </ul>
    );
  },
);
